export default __webpack_public_path__ + "static/media/icon-lying.1ce75c71.svg";